import { render } from "./UpOrDownIndicators.vue?vue&type=template&id=0618d908"
import script from "./UpOrDownIndicators.vue?vue&type=script&lang=js"
export * from "./UpOrDownIndicators.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__